module.exports = __webpack_public_path__ + "_assets/img/delete-gray.699bb14c.svg";